/**
 * Phase 3 shell unification — `Navbar` is now an alias for the unified
 * `<SiteNav>` (see `./site-nav.tsx`). Every page that previously
 * imported the old app navbar gets the unified shell automatically.
 *
 * New code should import `SiteNav` directly; this shim exists so the
 * ~40 existing call sites don't all need touching in one sweep.
 *
 * @deprecated import { SiteNav } from "@/components/layout/site-nav"
 */

export { SiteNav as Navbar } from "./site-nav";
